import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { indexOf, find } from 'lodash';
import Fa from 'react-fontawesome';

import styles from './styles.css';


class MappingToggleRenderer extends Component {
  constructor(args) {
    super(args);
    this.state = {};
    this.handleOnClick = this.handleOnClick.bind(this);
  }

  getMapping() {
    const {
      context: { mappings },
      colDef: { colId },
    } = this.props;
    return find(mappings, { _id: colId });
  }

  handleOnClick() {
    const { data } = this.props;
    const mapping = this.getMapping();
    if (!mapping) {
      return null;
    }
    const { value } = data;
    this.props.onToggleValue(mapping, value);
  }
  renderContent() {
    const { 
      data, isRadio,
      context: { updatingRowId, updatingColId },
    } = this.props;
    if (!data) {
      return null;
    }
    const mapping = this.getMapping();
    if (!mapping) {
      return null;
    }
    const { value } = data;
    const values = mapping.values || [];
    const active = indexOf(values, value) >= 0;

    const iconPrefix = isRadio ? 'circle' : 'square';
    let icon = active ? `check-${iconPrefix}` : `${iconPrefix}-o`;

    const iconCls = [styles.checkCellIcon];
    let spin = false;
    const divStyles = {};
    if (updatingRowId === data.value && updatingColId === mapping._id) {
      spin = true;
      icon = 'spinner';
      divStyles.cursor = 'not-allowed';
    } else {
      divStyles.cursor = 'pointer';
    }
    if (updatingRowId !== null || updatingColId !== null) {
      iconCls.push('text-muted');
      divStyles.cursor = 'not-allowed';
    } else if (active) {
      iconCls.push('text-success');
    }                  
    return (
      <div 
        className="text-center" 
        style={divStyles} 
        onClick={this.handleOnClick}
      >
        <Fa name={icon} className={iconCls.join(' ')} spin={spin} />
      </div>
    );
  }
  render() {
    const { node } = this.props;
    const isGrouped = node && node.group;
    if (!isGrouped || !this.props.data) {
      return this.renderContent();
    }
    return null;
  }
}


MappingToggleRenderer.propTypes = {
  data: PropTypes.shape({
    _id: PropTypes.string,
    description: PropTypes.string,
  }),
  node: PropTypes.shape({
    group: PropTypes.bool,
  }).isRequired,
  colDef: PropTypes.shape({
    colId: PropTypes.string,
  }).isRequired,
  isRadio: PropTypes.bool,
  context: PropTypes.shape({
    updatingColId: PropTypes.string,
    updatingRowId: PropTypes.string,
    mappings: PropTypes.arrayOf(PropTypes.shape({})),
  }).isRequired,
  onToggleValue: PropTypes.func,
};

MappingToggleRenderer.defaultProps = {
  isRadio: false,
  data: null,
  onToggleValue: () => {},
};

export default MappingToggleRenderer;
